import type { TranslationDictionary } from "./types";

export const KO_DICTIONARY: TranslationDictionary = {
    "app.newTask": "새로 만들기",
    "app.newTaskAria": "새 채팅 만들기",
    "sidebar.searchPlaceholder": "프롬프트 또는 작업 ID 검색",
    "sidebar.filters": "작업 필터",
    "sidebar.allRatios": "모든 비율",
    "sidebar.allOrientations": "모든 방향",
    "sidebar.allModes": "모든 모드",
    "sidebar.allResolutions": "모든 해상도",
    "sidebar.activeTasks": "활성 작업",
    "sidebar.topAnchors": "상단 시간 탐색",
    "sidebar.bottomAnchors": "하단 시간 탐색",
    "sidebar.resize": "사이드바 크기 조정",
    "batch.selected": "0 선택됨",
    "batch.selectedCount": "{count}개 선택됨",
    "batch.archivedCount": "채팅 {count}개 보관됨",
    "batch.archiveFailed": "일괄 보관 실패",
    "batch.runningCannotDeleteSelected": "선택한 채팅이 실행 중이므로 삭제할 수 없습니다.",
    "batch.deleteTitle": "채팅 {count}개를 삭제할까요?",
    "batch.deleteMessage": "그러면 로컬 이미지 파일도 삭제됩니다.",
    "batch.deleteSkippedDetail": "실행 중인 작업 {count}개는 유지됩니다",
    "batch.deleteSkippedSuffix": ", 실행 중인 작업 {count}개는 삭제되지 않았습니다",
    "batch.deletedCount": "채팅 {count}개 삭제됨{skipped}",
    "batch.deleteFailed": "일괄 삭제에 실패했습니다.",
    "action.archive": "보관",
    "action.delete": "삭제",
    "action.cancel": "취소",
    "action.edit": "편집",
    "action.clear": "지우기",
    "action.paste": "붙여넣기",
    "action.find": "찾기",
    "action.replace": "바꾸기",
    "action.close": "닫기",
    "action.confirm": "확인",
    "action.confirmQuestion": "작업을 확인하시겠습니까?",
    "action.refresh": "새로 고침",
    "action.save": "저장",
    "action.add": "추가",
    "action.new": "새로 만들기",
    "action.import": "가져오기",
    "action.export": "내보내기",
    "queue.empty": "대기 없음",
    "queue.emptyAria": "대기열 상태: 대기열에 있는 작업이 없습니다.",
    "queue.jumpTitle": "활성 작업으로 이동",
    "queue.emptyTitle": "대기 중인 작업이 없습니다.",
    "queue.channel": "채널 {count}",
    "queue.availableChannels": "사용 가능한 채널{usable}/{total}",
    "queue.dispatching": "예약 중 · 대기 {waiting}",
    "queue.runningWaiting": "실행 중 {running} · 대기 {waiting}",
    "queue.statusLabel": "대기열 상태:{text}·{channelText}. 활성 작업으로 이동하려면 클릭하세요.",
    "queue.runningActions": "작업 대기열 작업 실행 중",
    "queue.waitingActions": "작업 대기열 작업 대기 중",
    "queue.cancelRunning": "취소",
    "queue.cancelRunningTitle": "실행 중인 작업 취소",
    "queue.dragWaiting": "대기 작업을 다시 정렬하려면 드래그하세요.",
    "queue.dragSort": "정렬하려면 드래그하세요.",
    "queue.moveUp": "위로",
    "queue.moveUpTitle": "대기 중인 작업을 위로 이동",
    "queue.moveDown": "아래로",
    "queue.moveDownTitle": "대기 중인 작업을 아래로 이동합니다.",
    "queue.promote": "맨 위로",
    "queue.promoteTitle": "대기 중인 작업을 맨 위로 이동",
    "queue.promoteFailed": "맨 위로 이동 실패",
    "queue.deleteWaitingShort": "삭제",
    "queue.deleteWaitingTitle": "대기 작업 삭제",
    "queue.deleteWaitingTitleConfirm": "대기 중인 작업을 삭제하시겠습니까?",
    "queue.deleteWaitingMessage": "대기열과 기록 목록에서 제거됩니다.",
    "queue.deleteQueuedFailed": "대기 중인 작업을 삭제하지 못했습니다.",
    "queue.queuedDeleted": "대기 중인 작업이 삭제되었습니다.",
    "queue.cancelRunningConfirm": "작업 취소",
    "queue.cancelRunningTitleConfirm": "실행 중인 작업을 취소하시겠습니까?",
    "queue.cancelRunningMessage": "현재 작업이 중지됩니다. 기록은 유지됩니다.",
    "queue.cancelRunningFailed": "작업을 취소하지 못했습니다.",
    "queue.runningCancelled": "작업이 취소되었습니다.",
    "queue.reorderFailed": "대기열을 재정렬하지 못했습니다.",
    "queue.realtimeUpdateFailed": "라이브 상태를 업데이트하지 못했습니다.",
    "queue.realtimeDisconnected": "라이브 상태 연결이 끊어졌습니다. 복구하려면 페이지를 새로 고치세요.",
    "queue.readFailed": "대기열을 로드하지 못했습니다.",
    "status.waiting": "작업 대기 중",
    "status.shownActiveTasks": "활성 작업 표시 중",
    "status.jsonCopied": "JSON복사됨",
    "taskStatus.submitting": "제출 중",
    "taskStatus.running": "생성 중",
    "taskStatus.runningWithElapsed": "생성 중 ·{elapsed}",
    "taskStatus.completed": "완료됨",
    "taskStatus.partialFailed": "부분적으로 실패함",
    "taskStatus.failed": "실패",
    "taskStatus.queued": "대기 중",
    "taskStatus.unknown": "알 수 없는 상태",
    "taskStatus.task": "작업",
    "taskStatus.connectionInterrupted": "연결이 중단되었습니다.",
    "taskStatus.lastFailed": "마지막 실패",
    "taskStatus.waitingRetry": "{reason}, 재시도 대기 중({attempt}/{max}시도)",
    "taskStatus.retrying": "{reason}, 재시도 중({attempt}/{max}시도)",
    "taskStatus.nonRetryableAttempt": "{attempt}/{max}시도, 재시도할 수 없음",
    "taskStatus.manualRetryAvailable": "중지되었습니다. 실패한 이미지는 수동으로 다시 시도할 수 있습니다.",
    "taskStatus.waitingRetryShort": "재시도 대기",
    "taskStatus.retryingShort": "재시도 중",
    "taskStatus.nonRetryableShort": "재시도 불가",
    "taskStatus.manualRetryShort": "수동 재시도",
    "taskStatus.stoppedShort": "중지됨",
    "taskStatus.runtime": "기간{duration}",
    "taskStatus.runtimeCompleted": "기간{duration}· 완료{time}",
    "taskStatus.completedAt": "완료됨{time}",
    "taskCard.count": "이미지 {count}개",
    "taskCard.successCount": "성공 {count}",
    "taskCard.failedCount": "실패 {count}",
    "taskCard.runningCount": "생성 중 {count}",
    "taskCard.waitingCount": "대기 중 {count}",
    "taskCard.textToImageThumb": "텍스트-이미지 작업 축소판",
    "taskCard.imageToImageThumb": "이미지 대 이미지 작업 썸네일",
    "taskCard.failedThumb": "작업이 실패했습니다.",
    "taskCard.textBadge": "T",
    "taskMode.edit": "편집",
    "taskMode.generate": "생성",
    "document.generatingQueue": "생성 중 · 대기열 {total}",
    "document.queuedWaiting": "대기열 · 대기 {count}",
    "runFeedback.editing": "편집 중",
    "runFeedback.generating": "생성 중",
    "runFeedback.status": "{action}, 경과{elapsed}",
    "footer.archive": "보관함",
    "footer.archiveCount": "보관함 {count}",
    "footer.historyLibrary": "기록",
    "historyLibrary.openFull": "전체 기록 라이브러리 열기",
    "history.documentTitle": "기록 - 阿泰生图",
    "history.back": "생성기로 돌아가기",
    "history.title": "기록",
    "history.loading": "로드 중",
    "history.total": "{total}개 작업 · {archived}개 보관됨",
    "history.search": "검색",
    "history.searchPlaceholder": "프롬프트 또는 작업 ID 검색",
    "history.clear": "지우기",
    "history.type": "유형",
    "history.allTypes": "모든 유형",
    "history.type.textToImage": "텍스트→이미지",
    "history.type.imageToImage": "이미지→이미지",
    "history.month": "월",
    "history.status": "상태",
    "history.promptMode": "프롬프트 처리",
    "history.size": "크기",
    "history.quality": "품질",
    "history.ratio": "비율",
    "history.orientation": "방향",
    "history.backend": "백엔드",
    "history.provider": "공급자",
    "history.archived": "보관됨",
    "history.all": "모두",
    "history.allMonths": "모든 달",
    "history.allStatuses": "모든 상태",
    "history.allPromptModes": "모든 모드",
    "history.allSizes": "모든 크기",
    "history.allQualities": "모든 품질",
    "history.allRatios": "모든 비율",
    "history.ratioOther": "기타",
    "history.allOrientations": "모든 방향",
    "history.allBackends": "모든 백엔드",
    "history.allProviders": "모든 공급자",
    "history.unarchived": "보관되지 않음",
    "history.archivedOnly": "보관됨",
    "history.tasksAria": "기록 작업",
    "history.taskListTitle": "기록 작업",
    "history.browseNewest": "최신 항목부터 찾아보기",
    "history.view": "보기",
    "history.grid": "그리드",
    "history.list": "목록",
    "history.sort": "정렬",
    "history.newest": "최신 것부터",
    "history.oldest": "오래된 것부터",
    "history.refresh": "새로 고침",
    "history.selectedCount": "{count}개 작업이 선택됨",
    "history.confirmDelete": "삭제 확인",
    "history.detail": "작업 세부정보",
    "history.detailTitle": "기록 작업",
    "history.closeDetail": "작업 세부정보 닫기",
    "history.resizeFilters": "필터 사이드바 크기 조정",
    "history.resizeDetail": "세부정보 창 크기 조정",
    "history.detailEmpty": "세부정보를 보려면 기록 작업을 선택하세요.",
    "history.loadingDetail": "세부정보 로드 중...",
    "history.loadMore": "더 로드하기",
    "history.loadingMore": "로드 중...",
    "history.noMore": "더 이상 작업이 없습니다.",
    "history.loadFailed": "로드에 실패했습니다. 다시 시도하려면 새로고침하거나 계속 스크롤하세요.",
    "history.summaryFailed": "요약을 로드하지 못했습니다.",
    "history.tasksFailed": "작업을 로드하지 못했습니다.",
    "history.detailFailed": "세부정보를 로드하지 못했습니다.",
    "history.noMatches": "일치하는 작업이 없습니다.",
    "history.loadedCount": "{count}개 로드됨",
    "history.windowNotice": "표시되는 목록은 {count}개 작업으로 제한됩니다. 위아래로 스크롤하면 필요한 인접 작업을 복원합니다.",
    "history.selectTask": "작업 선택",
    "history.viewing": "보기",
    "history.noPreview": "미리보기 이미지 없음",
    "history.downloadAll": "ZIP 다운로드",
    "history.downloadImage": "이미지 다운로드",
    "history.downloadSelected": "선택 항목 다운로드",
    "history.deleteUnselected": "선택하지 않은 항목 삭제",
    "history.confirmDeleteUnselected": "선택하지 않은 항목 삭제 확인",
    "history.selected": "선택됨",
    "history.select": "선택",
    "history.downloadIndex": "{index} 다운로드",
    "history.addReference": "참조 추가",
    "history.outputActions": "결과 이미지 작업",
    "history.inputReferences": "입력 참조",
    "history.inputReferenceIndex": "입력 참조 {index}",
    "history.copyPrompt": "프롬프트 복사",
    "history.copyPrompts": "프롬프트 복사",
    "history.copyPromptShort": "복사",
    "history.copyPromptPanel": "{title} 복사",
    "history.copyOutputPromptPanel": "이미지 {index}의 수정된 프롬프트 복사",
    "history.copyTaskIds": "작업 ID 복사",
    "history.reuseTask": "생성기에서 보기",
    "history.downloadTask": "다운로드",
    "history.downloadSelectedTasks": "일괄 다운로드",
    "history.contextMenuLabel": "기록 작업 상황에 맞는 메뉴",
    "history.promptCopied": "프롬프트 복사됨",
    "history.promptsCopied": "작업 {count}개의 프롬프트를 복사했습니다",
    "history.taskIdsCopied": "작업 ID {count}개를 복사했습니다",
    "history.promptCopiedShort": "복사됨",
    "history.promptCopyFailed": "프롬프트를 복사하지 못했습니다.",
    "history.promptCopyFailedShort": "실패",
    "history.noPrompt": "이 작업에는 복사할 프롬프트가 없습니다.",
    "history.noPromptShort": "비어 있음",
    "history.downloadStarted": "다운로드가 시작되었습니다",
    "history.batchDownloadStarted": "작업 {count}개에 대한 다운로드가 시작되었습니다.",
    "history.noDownloadableOutputs": "다운로드 가능한 이미지가 없습니다.",
    "history.confirmDeleteSelected": "선택한 삭제 확인",
    "history.openPreview": "미리보기 열기",
    "history.closePreview": "미리보기 닫기",
    "history.untitled": "제목 없음",
    "history.promptCompare": "프롬프트 비교",
    "history.promptOriginal": "원래 프롬프트",
    "history.promptSubmitted": "최적화된 프롬프트",
    "history.promptRevised": "수정된 결과",
    "history.outputRevisedPromptTitle": "이미지 {index} 수정 프롬프트",
    "history.outputRevisedPromptNotice": "각 이미지에는 이미지별 수정 프롬프트가 표시됩니다.",
    "history.promptEmpty": "내용 없음",
    "history.promptMode.strict": "충실",
    "history.promptMode.original": "원문",
    "history.promptMode.off": "자동",
    "history.quality.high": "높음",
    "history.quality.medium": "매체",
    "history.quality.low": "낮음",
    "history.quality.auto": "자동",
    "footer.batch": "배치",
    "footer.storage": "저장",
    "footer.apiStatus": "API상태: 정상",
    "footer.version": "버전{version}",
    "footer.versionInfo": "버전 정보",
    "footer.versionLoading": "버전...",
    "footer.updateBadge": "새 버전 사용 가능",
    "footer.updateAvailable": "새 버전{version}",
    "version.title": "버전 및 업데이트",
    "version.loading": "버전 상태를 읽는 중",
    "version.current": "현재 버전",
    "version.latest": "최신 버전",
    "version.source": "런타임",
    "version.sourcePortable": "휴대용 패키지",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "소스 체크아웃",
    "version.upToDate": "이미 최신 버전을 사용하고 있습니다.",
    "version.updateAvailable": "버전{version}을(를) 사용할 수 있습니다.WebUI서버 창을 닫은 후 업데이트 프로그램을 실행하여 업그레이드하세요.",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "이 런타임은 이식 가능한 패키지가 아니므로 업데이트 프로그램을 자동으로 시작할 수 없습니다.",
    "version.openUpdater": "업데이터 시작",
    "version.release": "릴리스 보기",
    "version.updaterStarted": "업데이터가 시작되었습니다. 현재WebUI서버 창을 닫은 다음 업데이트 프로그램의 지시를 따릅니다.",
    "version.updaterFailed": "업데이트 프로그램을 시작할 수 없습니다. 패키지에서 업데이터 스크립트를 수동으로 실행합니다.",
    "version.historyTitle": "업데이트 기록",
    "version.historyEmpty": "업데이트 기록이 없습니다",
    "version.currentBadge": "현재",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "공식 로고, 슬로건 및 비즈니스 시그니처 라이브러리에 여러 브랜드와 사업군, 가로형·세로형 및 반전 버전을 추가했습니다.",
    "version.change.material_picker_modal": "소재 선택이 대화상자로 바뀌고, 큰 썸네일·카테고리·검색·다중 선택으로 입력 영역에 추가할 수 있습니다.",
    "version.change.brand_name": "제품명을 AI 혁신 스튜디오로 변경하고 영문명도 AI Innovation Studio로 통일했습니다.",
    "version.change.brand_templates": "선택 가능한 브랜드 템플릿과 로고·슬로건 등 브랜드 요소의 자동 합성을 추가했습니다.",
    "version.change.brand_preview": "브랜드 결과를 미리보기, 기록, 확대 보기, 다운로드에서 일관되게 표시하며 원본 이미지 전환도 유지합니다.",
    "version.change.mobile_workspace": "모바일 헤더, 작업 표시줄, 소재 요약, 빈 미리보기를 압축해 핵심 제작 흐름을 더 많이 보여 줍니다.",
    "version.change.task_center": "모바일 작업 센터를 압축하고 실행 중·대기 중 작업 배지를 추가했습니다.",
    "version.change.brand_launch": "Hengtai 브랜드 시각 자료를 포함한 브랜드 모바일 환경을 처음 출시했습니다.",
    "version.change.core_workflow": "이미지 생성, 작업 대기열, 기록, 갤러리, 설정의 기본 워크플로를 제공했습니다.",
    "notifications.title": "작업 알림",
    "notifications.unread": "알림, 읽지 않음 {count}개",
    "notifications.unreadSummary": "읽지 않음 {count}개",
    "notifications.empty": "작업 알림 없음",
    "notifications.taskFailed": "작업이 실패했습니다.",
    "notifications.taskPartial": "작업이 부분적으로 완료되었습니다.",
    "notifications.taskCompleted": "작업 완료",
    "notifications.generationFailed": "생성 실패",
    "notifications.successCount": "성공 {count}",
    "notifications.resultAvailable": "결과 확인 가능",
    "notifications.failedCount": "실패 {count}",
    "notifications.systemUnsupported": "이 브라우저는 시스템 알림을 지원하지 않습니다.",
    "notifications.systemBlocked": "시스템 알림이 브라우저에 의해 차단되었습니다. 브라우저 설정에서 활성화하세요.",
    "notifications.systemDenied": "시스템 알림이 활성화되지 않았습니다.",
    "notifications.systemEnabled": "시스템 알림이 활성화되었습니다.",
    "notifications.taskMissing": "작업이 존재하지 않거나 삭제되었습니다.",
    "theme.label": "테마",
    "theme.system": "시스템",
    "theme.light": "라이트",
    "theme.dark": "다크",
    "language.label": "표시 언어",
    "language.zh": "中",
    "language.zhCN": "중국어 간체",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "인증 소스",
    "auth.checking": "인증 확인 중",
    "auth.missingCodexSession": "Codex 세션이 감지되지 않았습니다.",
    "auth.switchFailed": "인증 소스를 전환하지 못했습니다.",
    "auth.sourceUnavailable": "{source}사용할 수 없음",
    "auth.notActive": "활동하지 않음",
    "api.settings": "시스템 설정",
    "api.provider": "API 공급자",
    "imageInput.title": "이미지 입력",
    "imageInput.uploadAria": "이미지와 파일을 클릭, 드롭 또는 붙여넣기",
    "imageInput.uploadFull": "이미지와 파일을 클릭, 드롭 또는 붙여넣기",
    "imageInput.uploadCompact": "입력 추가",
    "imageInput.uploadSubtitle": "이미지 및 Responses 참조 파일 지원",
    "imageInput.recent": "최근 업로드",
    "imageInput.recentBadge": "최근",
    "imageInput.uploadBadge": "업로드",
    "imageInput.addToGallery": "갤러리에 추가",
    "imageInput.addToGalleryShort": "갤러리",
    "imageInput.removeImage": "이미지 제거",
    "imageInput.editedBadge": "편집됨",
    "imageInput.editImage": "편집{name}",
    "imageInput.deletedRecent": "최근 업로드가 삭제되었습니다.",
    "imageInput.deletedGallery": "갤러리 이미지가 삭제되었습니다.",
    "recentAssets.defaultName": "최근 업로드",
    "recentAssets.use": "{name}사용",
    "recentAssets.delete": "{name}삭제",
    "recentAssets.deleteTitle": "최근 업로드를 삭제하시겠습니까?",
    "recentAssets.deleteMessage": "최근 업로드에서 이미지가 제거됩니다. 현재 이미지 입력으로 선택된 경우 현재 입력에서 제거됩니다. 이 최근 업로드를 참조하는 기록 작업은 해당 입력 미리 보기를 잃게 됩니다. 공개 갤러리는 영향을 받지 않습니다.",
    "recentAssets.loadFailed": "최근 업로드를 로드하지 못했습니다.",
    "recentAssets.deleteFailed": "최근 업로드를 삭제하지 못했습니다.",
    "recentAssets.deleted": "최근 업로드가 삭제되었습니다.",
    "inputSource.uploadFallback": "업로드된 이미지",
    "inputSource.galleryFallback": "갤러리 이미지",
    "inputSource.focusPasteFallback": "{prefix}. 이미지 입력이 집중됩니다. 이미지를 붙여넣으려면{shortcut}을 누르세요.",
    "inputSource.pastedCount": "클립보드 이미지 {count}개를 붙여넣었습니다",
    "inputSource.droppedCount": "드롭한 이미지 {count}개를 추가했습니다",
    "inputSource.dropImagesOnly": "이미지 파일만 삭제",
    "inputSource.clipboardUnsupported": "이 브라우저는 클립보드를 직접 읽을 수 없습니다.",
    "inputSource.clipboardEmpty": "클립보드 이미지가 없습니다.",
    "inputSource.clipboardDenied": "브라우저가 직접 클립보드 액세스를 차단했습니다.",
    "inputSource.clipboardReadFailed": "클립보드를 읽지 못했습니다.",
    "status.missingGalleryReference": "갤러리 참조 이미지가 삭제되었습니다. 생성하기 전에 제거하세요.",
    "status.missingRecentReference": "최근 업로드한 참조 이미지가 삭제되었습니다. 생성하기 전에 제거하세요.",
    "status.emptyPrompt": "프롬프트를 입력하세요",
    "status.editNeedsImage": "편집 모드에는 하나 이상의 이미지가 필요합니다.",
    "status.loadedTask": "로드된 작업{taskId}",
    "status.reusedTask": "생성기에서 열린 작업{taskId}",
    "status.loadingHistoryInputs": "기록 입력 이미지 로드 중...",
    "status.historyInputLoadFailed": "기록 입력 이미지를 로드하지 못했습니다:{url}",
    "referenceCollector.alreadyStaged": "이미 임시 참조로 추가되었습니다",
    "referenceCollector.staged": "참조 이미지 {count}개를 임시 추가했습니다",
    "referenceCollector.title": "임시 참조 · {count}",
    "referenceCollector.addAll": "모든 참조 추가",
    "referenceCollector.itemFallback": "임시 참조",
    "referenceCollector.remove": "임시 참조 제거",
    "referenceCollector.cleared": "임시 참조를 지웠습니다",
    "referenceCollector.added": "참조 이미지 {count}개를 추가했습니다",
    "referenceCollector.addFailed": "임시 참조를 추가하지 못했습니다",
    "referenceCollector.readFailed": "이미지를 읽지 못했습니다:{status}",
    "gallery.quick": "빠른 갤러리",
    "gallery.current": "현재 카테고리 갤러리",
    "gallery.categories": "갤러리 카테고리",
    "gallery.categoryPortrait": "초상화",
    "gallery.categoryCharacter": "문자",
    "gallery.categoryProduct": "제품",
    "gallery.categoryPortraitRole": "인물 사진 참고",
    "gallery.categoryCharacterRole": "캐릭터 참조",
    "gallery.categoryProductRole": "제품 참조",
    "gallery.referenceRole": "참고 이미지",
    "gallery.manage": "갤러리 관리",
    "gallery.loadFailed": "갤러리를 로드하지 못했습니다.",
    "gallery.imageOrderUpdateFailed": "이미지 순서를 업데이트하지 못했습니다.",
    "gallery.imageOrderUpdated": "이미지 순서가 업데이트되었습니다.",
    "gallery.categoryName": "카테고리 이름",
    "gallery.categoryPromptRole": "프롬프트 용도",
    "gallery.categorySave": "저장",
    "gallery.categoryDelete": "삭제",
    "gallery.categoryLoadFailed": "카테고리를 로드하지 못했습니다.",
    "gallery.categoryNameRequired": "카테고리 이름을 입력하세요",
    "gallery.categoryCreateFailed": "카테고리를 추가하지 못했습니다.",
    "gallery.categoryCreated": "카테고리가 추가되었습니다",
    "gallery.categorySaveFailed": "카테고리를 저장하지 못했습니다.",
    "gallery.categorySaved": "카테고리가 저장되었습니다",
    "gallery.categoryDeleteTitle": "갤러리 카테고리를 삭제하시겠습니까?",
    "gallery.categoryDeleteMessage": "이 카테고리의 이미지는 다른 카테고리로 이동됩니다. 갤러리 이미지는 삭제되지 않습니다.",
    "gallery.categoryDeleteConfirm": "카테고리 삭제",
    "gallery.categoryDeleteFailed": "카테고리를 삭제하지 못했습니다.",
    "gallery.categoryDeletedMigrated": "카테고리 \"{name}\"이(가) 삭제되고 이미지가 마이그레이션되었습니다.",
    "gallery.categoryOrderUpdateFailed": "카테고리 순서를 업데이트하지 못했습니다.",
    "gallery.categoryOrderUpdated": "카테고리 순서가 업데이트되었습니다.",
    "gallery.categoryFallback": "갤러리 카테고리",
    "gallery.imageFallback": "갤러리 이미지",
    "gallery.imageLoadFailed": "이 이미지를 로드하지 못했습니다.",
    "gallery.editImageLoadFailed": "편집을 위해 이 이미지를 로드하지 못했습니다.",
    "gallery.cannotAddImage": "이 이미지는 갤러리에 추가할 수 없습니다",
    "gallery.nameRequired": "갤러리 이름을 입력하세요",
    "gallery.saveFailed": "갤러리 이미지 저장 실패",
    "gallery.savedAsReference": "갤러리에 추가하고 갤러리 참조로 전환했습니다.",
    "gallery.renameImage": "갤러리 이미지 이름 바꾸기",
    "gallery.moveToCategory": "카테고리로 이동",
    "gallery.categoryRequired": "갤러리 카테고리를 선택하세요",
    "gallery.promptNoteTitle": "갤러리 참조 노트",
    "gallery.updateFailed": "갤러리를 업데이트하지 못했습니다.",
    "gallery.selectImageFile": "이미지 파일을 선택하세요",
    "gallery.replaceImageFailed": "갤러리 이미지를 교체하지 못했습니다.",
    "gallery.replacedImage": "\"{name}\"의 소스 이미지를 교체했습니다.",
    "gallery.deleteImageTitle": "갤러리 이미지를 삭제하시겠습니까?",
    "gallery.deleteImageMessage": "기록 작업 참조가 삭제된 것으로 표시됩니다.",
    "gallery.deleteFailed": "갤러리 이미지를 삭제하지 못했습니다.",
    "gallery.deletedSuffix": "(삭제됨)",
    "gallery.editImageLabel": "갤러리 이미지 편집",
    "gallery.fieldCategory": "카테고리",
    "gallery.fieldPromptNote": "참고사항",
    "gallery.fieldName": "이름",
    "quickGallery.empty": "{category}이미지 없음",
    "promptGallery.remove": "@{name}제거",
    "prompt.title": "프롬프트",
    "prompt.editorLabel": "프롬프트",
    "prompt.placeholder": "생성하거나 편집하려는 이미지를 설명하세요. 갤러리 참조의 경우 @, 색상 코드의 경우 #, 프롬프트 스니펫의 경우 ~를 입력합니다.",
    "prompt.run": "생성 시작",
    "prompt.runEdit": "편집 시작",
    "prompt.runTitle": "생성(Cmd+Enter)",
    "prompt.runEditTitle": "편집 시작(Cmd+Enter)",
    "prompt.findPanel": "프롬프트 찾기 및 바꾸기",
    "prompt.findText": "텍스트 찾기",
    "prompt.replaceWith": "다음으로 교체",
    "prompt.findActions": "작업 찾기 및 바꾸기",
    "prompt.countZero": "0개 일치",
    "prompt.matchCount": "{count}개 일치",
    "prompt.foundCount": "일치 항목 {count}개를 찾았습니다",
    "prompt.noMatch": "일치하는 텍스트가 없습니다.",
    "prompt.replacedCount": "일치 항목 {count}개를 바꿨습니다",
    "prompt.closeFind": "찾기를 닫고 바꾸기",
    "prompt.recentTemplates": "최근 템플릿",
    "prompt.manageTemplates": "템플릿 관리",
    "promptModel.galleryHeader": "참조 이미지 참고사항:",
    "promptModel.galleryInstruction": "- 참조 이미지 {number}: 갤러리 \"{name}\", 용도: {role}. 프롬프트의 @{name}은 이 이미지를 가리킵니다.{note}",
    "outputSettings.title": "출력 설정",
    "output.lock.lock": "매개변수 잠금",
    "output.lock.unlock": "잠금 해제 및 편집",
    "output.lock.current": "현재 잠금",
    "output.lock.task": "선택한 작업 매개변수",
    "output.lock.adoptTask": "이 작업 매개변수 사용",
    "output.lock.frame": "화면 비율",
    "output.lock.outputCount": "출력 수",
    "output.lock.output": "출력",
"output.lock.search": "검색",
    "output.lock.call": "호출",
    "output.lock.sheets": "장",
    "output.lock.imageModel": "이미지 모델",
    "output.lock.prompt": "프롬프트",
    "output.lock.fileFormat": "파일 형식",
    "output.lock.taskHint": "선택한 작업의 매개변수만 표시합니다. 현재 잠금은 유지됩니다. 사용해도 시스템 채널은 변경되지 않습니다.",
    "output.lock.lockedHint": "매개변수가 고정되었습니다. 오른쪽 위 잠금 아이콘으로 편집하세요.",
    "output.lock.enabled": "켜짐",
    "output.lock.disabled": "꺼짐",
    "output.mainModel": "메인 모델",
    "output.selectMainModel": "메인 모델 선택",
    "output.mainModelCustomForInput": "현재 입력에 사용자 정의 모델을 사용합니다.",
    "output.apiDirect": "API직접",
    "output.apiToolModel": "API 이미지 생성 모델 사용",
    "output.mainModelUnused": "이 요청에는 기본 모델이 사용되지 않습니다.",
    "output.webSearch": "웹 검색",
    "output.webSearchToggle": "켜짐",
    "output.webSearchTitle": "먼저 웹을 검색한 다음 이 세대를 위해 사용하십시오.Codex및API응답만",
    "output.promptMode": "프롬프트 처리",
    "output.modeOriginal": "원문",
    "output.modeStrict": "충실",
    "output.modeCreative": "자동",
    "output.promptHelp": "프롬프트 처리 설명 보기",
    "output.promptHelpTitle": "프롬프트 처리",
    "output.promptHelp.responsesChannel": "Responses · 메인 모델 참여",
    "output.promptHelp.imagesChannel": "Images · 직접 생성",
    "output.promptHelp.responses.original": "원문을 메인 모델에 전달하고 이미지 도구가 가능한 한 그대로 사용하도록 요청합니다. 단, revised prompt가 생성될 수 있습니다.",
    "output.promptHelp.responses.strict": "메인 모델이 정리하거나 확장할 수 있지만 피사체, 텍스트, 색상, 구도 같은 필수 조건은 유지합니다.",
    "output.promptHelp.responses.automatic": "추가 제약 없이 메인 모델이 해석하고 최적화한 뒤 이미지 도구를 호출합니다.",
    "output.promptHelp.images.original": "앱 수준의 규칙을 추가하지 않고 원문을 이미지 API에 직접 제출합니다.",
    "output.promptHelp.images.strict": "원문과 충실도 규칙을 함께 제출해 모든 필수 조건의 유지를 강조합니다.",
    "output.promptHelp.images.automatic": "이미지 API의 기본 방식으로 제출하며 갤러리 참조 같은 필수 설명은 포함합니다.",
    "output.sizeMode": "크기 모드",
    "output.sizePreset": "사전 설정",
    "output.sizeCustom": "사용자 정의",
    "output.orientation": "방향",
    "output.square": "정사각형",
    "output.portrait": "초상화",
    "output.landscape": "풍경",
    "output.resolution": "해상도",
    "output.pixelSize": "픽셀 크기",
    "output.width": "너비",
    "output.height": "높이",
    "output.swapSize": "너비와 높이 교체",
    "output.customSizeHint": "단위px· 16-3840 · 16의 배수 · ≤3:1",
    "output.imageSizeUnavailable": "이미지 크기를 사용할 수 없습니다.",
    "output.imageLoadFailed": "이미지를 로드하지 못했습니다.",
    "output.customSizeRequired": "너비와 높이를 입력하세요.",
    "output.customSizeBounds": "너비와 높이는 16-3840이어야 합니다.px",
    "output.customSizeMultiple": "너비와 높이는 16의 배수여야 합니다.",
    "output.customSizeRatio": "긴 변과 짧은 변의 비율은 3:1을 초과할 수 없습니다.",
    "output.customSizePixels": "총 픽셀은 655,360-8,294,400이어야 합니다.",
    "output.ratioLock": "비율 잠금(선택 사항)",
    "output.customRatio": "사용자 정의 가로 세로 비율",
    "output.ratioWidth": "승",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "첫 번째 참조 이미지 종횡비 사용",
    "output.useFirstImage": "이미지에서",
    "output.ratioHint": "무료 크기를 원하면 비워두세요. 동기화하려면 둘 다 입력하세요.",
    "output.ratio": "비율",
    "output.quality": "품질",
    "output.qualityAuto": "자동",
    "output.qualityLow": "낮음",
    "output.qualityMedium": "매체",
    "output.qualityHigh": "높음",
    "output.quantity": "수",
    "output.pixelPreview": "출력 픽셀: 1024 x 1024px",
    "output.pixelPreviewValue": "출력 픽셀:{value}",
    "output.pixelPreviewAuto": "출력 픽셀: 자동(OpenAI가 자동으로 선택)",
    "output.format": "형식",
    "output.compression": "압축",
    "output.moderation": "중재",
    "preview.title": "미리보기",
    "preview.selectedZero": "0 선택됨",
    "preview.selectedCount": "선택됨{selected}/{total}",
    "preview.downloadSelected": "선택 항목 다운로드",
    "preview.deleteUnselected": "선택하지 않은 항목 삭제",
    "preview.downloadAll": "ZIP 다운로드",
    "preview.empty": "아직 이미지가 없습니다",
    "preview.taskFailed": "작업이 실패했습니다.",
    "preview.partialFailed": "일부 이미지가 실패했습니다.",
    "preview.failedOutput": "이미지{index}실패",
    "preview.progressLine": "완료{generated}/{total}· 경과{elapsed}",
    "preview.failureLine": "완료{generated}/{total}· 실패{failed}",
    "preview.elapsedLine": "경과{elapsed}",
    "preview.lastError": "마지막 오류:{error}",
    "preview.continueGenerating": "계속되는 세대",
    "preview.waitingContinue": "계속하는 중입니다.",
    "preview.retryFailed": "실패한 이미지 재시도",
    "preview.acceptSuccesses": "성공적인 결과를 수락",
    "preview.generateMode": "세대",
    "preview.editMode": "편집",
    "preview.runningTitle": "{mode}실행 중",
    "preview.submittingTitle": "작업 제출 중",
    "preview.queuedTitle": "작업이 대기 중입니다.",
    "preview.submittingDetail": "입력을 저장하고 작업을 대기열에 추가합니다. 생성이 자동으로 시작됩니다.",
    "preview.queuedDetail": "작업이 대기열에 있으며 사용 가능한 채널을 기다리고 있습니다.",
    "preview.featured": "선택됨",
    "preview.addFeatured": "결과 선택",
    "preview.selectedFeatured": "선택됨",
    "preview.removeFeatured": "결과 선택 취소",
    "preview.selectionAdded": "결과가 선택됨",
    "preview.selectionRemoved": "결과가 선택 취소됨",
    "preview.selectionUpdateFailed": "선택 항목을 업데이트하지 못했습니다.",
    "preview.noUnselectedOutputs": "삭제할 선택되지 않은 이미지가 없습니다.",
    "preview.deleteUnselectedTitle": "선택되지 않은 이미지를 삭제하시겠습니까?",
    "preview.deleteUnselectedMessage": "이 작업에서 선택되지 않은 결과에 대한 로컬 이미지 파일이 삭제됩니다.",
    "preview.deleteUnselectedDetail": "{selected}유지,{deleted}삭제",
    "preview.deleteUnselectedFailed": "선택되지 않은 이미지를 삭제하지 못했습니다.",
    "preview.deleteUnselectedDone": "선택되지 않은 이미지가 삭제되었습니다.",
    "preview.addReference": "참조 추가",
    "preview.stage": "임시 추가",
    "preview.stageReference": "임시 참조로 추가",
    "preview.prompt": "프롬프트",
    "preview.download": "다운로드",
    "preview.downloadImage": "이 이미지 다운로드",
    "lightbox.label": "이미지 미리보기",
    "lightbox.close": "미리보기 닫기",
    "lightbox.previous": "이전 이미지",
    "lightbox.next": "다음 이미지",
    "promptPopover.title": "프롬프트 비교",
    "promptPopover.summary": "원본{original}· 최적화{optimized}",
    "promptPopover.original": "원래 프롬프트",
    "promptPopover.optimized": "최적화된 프롬프트",
    "promptPopover.charCount": "{count}자",
    "promptPopover.empty": "없음",
    "promptPopover.notReturned": "반환되지 않음",
    "promptPopover.noOptimized": "최적화된 프롬프트가 반환되지 않았습니다.",
    "promptPopover.submitted": "제출된 프롬프트 보기",
    "promptPopover.close": "프롬프트 비교 닫기",
    "promptPopover.copyOptimized": "최적화된 프롬프트 복사",
    "promptPopover.copied": "복사됨",
    "taskContext.menuLabel": "작업 상황에 맞는 메뉴",
    "taskContext.view": "작업 보기",
    "taskContext.copyId": "작업 ID 복사",
    "taskContext.copyPrompt": "프롬프트 복사",
    "taskContext.revealOutput": "출력 폴더 열기",
    "taskContext.archive": "아카이브 작업",
    "taskContext.delete": "작업 삭제",
    "taskContext.idCopied": "작업 ID복사됨",
    "taskContext.promptCopied": "프롬프트 복사됨",
    "taskContext.noPrompt": "이 작업에는 복사할 프롬프트가 없습니다.",
    "taskContext.revealFailed": "출력 폴더를 열지 못했습니다.",
    "taskContext.revealOpened": "출력 폴더가 열렸습니다.",
    "taskContext.actionFailed": "작업 작업이 실패했습니다.",
    "taskActions.group": "작업 동작",
    "taskActions.deleteTitle": "작업을 삭제하시겠습니까?",
    "taskActions.deleteMessage": "로컬 이미지 파일도 삭제됩니다.",
    "taskActions.runningCannotDelete": "실행 중인 작업을 삭제할 수 없습니다.",
    "taskActions.updated": "작업 상태가 업데이트되었습니다.",
    "taskActions.archived": "채팅이 보관되었습니다.",
    "taskActions.archiveFailed": "보관 실패",
    "taskActions.deleted": "작업이 삭제되었습니다.",
    "taskActions.deleteFailed": "삭제 실패",
    "taskActions.noRetryableFailedImages": "이 작업에는 재시도할 실패한 이미지가 없습니다.",
    "taskActions.retryFailedOutputsFailed": "실패한 이미지를 다시 시도하지 못했습니다.",
    "taskActions.requeuedFailedImages": "실패한 이미지가 다시 대기열에 추가됨",
    "taskActions.noAcceptableSuccessImages": "이 작업에는 수락할 성공적인 이미지가 없습니다.",
    "taskActions.acceptSuccessesFailed": "성공적인 결과를 수락하지 못했습니다.",
    "taskActions.acceptedSuccesses": "성공적인 결과가 승인되었습니다.",
    "taskActions.viewedUpdateFailed": "읽기 상태를 업데이트하지 못했습니다.",
    "taskActions.failedFallback": "작업이 실패했습니다.",
    "taskList.empty": "아직 기록이 없습니다",
    "taskList.selectSession": "채팅 선택",
    "taskList.unreadUpdate": "읽지 않은 업데이트",
    "taskList.viewing": "보기",
    "taskDerived.usageLimited": "사용이 제한됨",
    "taskSubmit.requestFailed": "요청이 실패했습니다.",
    "taskSubmit.queued": "대기열에 작업이 추가되었습니다.",
    "taskSubmit.timeout": "백엔드가 응답하기 전에 작업 제출 시간이 초과되었습니다. 대기열을 새로 고쳐 추가되었는지 확인한 후 재시도할지 결정하세요.",
    "taskSubmit.failed": "작업 제출에 실패했습니다.",
    "templates.title": "프롬프트 템플릿",
    "templates.summary": "로컬 템플릿 라이브러리",
    "templates.availableCount": "사용 가능한 템플릿 {count}개",
    "templates.noMatch": "일치하는 템플릿이 없습니다.",
    "templates.empty": "템플릿 없음",
    "templates.favoriteBadge": "즐겨찾기",
    "templates.usageCount": "사용 {count}회",
    "templates.back": "뒤로",
    "templates.edit": "편집",
    "templates.copy": "복사",
    "templates.insert": "삽입",
    "templates.formTitle": "제목",
    "templates.formShortTitle": "짧은 제목",
    "templates.formCategory": "카테고리",
    "templates.formTags": "태그",
    "templates.formThumbnail": "썸네일",
    "templates.formContent": "내용",
    "templates.formNotes": "참고 사항",
    "templates.formFavorite": "즐겨찾기",
    "templates.thumbnailClear": "지우기",
    "templates.thumbnailNone": "선택된 항목 없음",
    "templates.thumbnailEmpty": "기록 썸네일 없음",
    "templates.newCategory": "새 카테고리",
    "templates.search": "템플릿, 태그 또는 콘텐츠 검색",
    "templates.filter": "템플릿 필터",
    "templates.all": "모두",
    "templates.categoryCommon": "공통",
    "templates.categoryPortrait": "초상화",
    "templates.categoryProduct": "제품",
    "templates.categoryRepair": "수리",
    "templates.categoryPoster": "포스터",
    "templates.categoryEcommerce": "전자상거래",
    "templates.favorite": "즐겨찾기",
    "templates.recent": "최근",
    "templates.category": "카테고리",
    "templates.loadFailed": "프롬프트 템플릿을 로드하지 못했습니다.",
    "templates.useStateUpdateFailed": "프롬프트 템플릿 사용 상태를 업데이트하지 못했습니다.",
    "templates.copied": "프롬프트 템플릿이 복사되었습니다.",
    "templates.copyFailed": "프롬프트 템플릿을 복사하지 못했습니다.",
    "templates.history": "기록",
    "templates.saveFailed": "프롬프트 템플릿을 저장하지 못했습니다.",
    "templates.saved": "프롬프트 템플릿이 저장되었습니다.",
    "templates.deleteFailed": "프롬프트 템플릿을 삭제하지 못했습니다.",
    "templates.deleted": "프롬프트 템플릿이 삭제되었습니다.",
    "templates.categoryAddFailed": "템플릿 카테고리를 추가하지 못했습니다.",
    "templates.categoryAdded": "템플릿 카테고리가 추가되었습니다.",
    "templates.categorySaveFailed": "템플릿 카테고리를 저장하지 못했습니다.",
    "templates.categorySaved": "템플릿 카테고리가 저장되었습니다.",
    "templates.categoryDeleteFailed": "템플릿 카테고리를 삭제하지 못했습니다.",
    "templates.categoryDeleted": "템플릿 카테고리가 삭제되었습니다.",
    "templates.importFailed": "템플릿 팩을 가져오지 못했습니다.",
    "templates.importedCount": "템플릿 {count}개를 가져왔습니다",
    "templates.exportFailed": "템플릿 팩을 내보내지 못했습니다.",
    "templates.exported": "템플릿 팩을 내보냈습니다.",
    "snippets.suggestLabel": "프롬프트 조각 선택기",
    "snippets.saveSelection": "저장",
    "snippets.saveSelectionLabel": "선택한 텍스트를 프롬프트 조각으로 저장",
    "snippets.popoverLabel": "프롬프트 스니펫",
    "snippets.defaultCategory": "공통",
    "snippets.loadFailed": "프롬프트 조각을 로드하지 못했습니다.",
    "snippets.remove": "~{tag}제거",
    "snippets.expand": "확장",
    "snippets.edit": "편집",
    "snippets.close": "닫기",
    "snippets.editTitle": "스니펫 편집",
    "snippets.saveTitle": "스니펫 저장",
    "snippets.shortTag": "짧은 태그",
    "snippets.title": "제목",
    "snippets.category": "카테고리",
    "snippets.content": "내용",
    "snippets.titlePlaceholder": "기본적으로 짧은 태그를 사용합니다.",
    "snippets.cancel": "취소",
    "snippets.save": "저장",
    "snippets.saveFailed": "프롬프트 스니펫을 저장하지 못했습니다.",
    "snippets.saved": "프롬프트 스니펫이 저장되었습니다.",
    "snippets.defaultTag": "공통 조각",
    "colors.white": "화이트",
    "colors.black": "블랙",
    "colors.warmBeige": "웜베이지",
    "colors.lightGreen": "연두색",
    "colors.brandGreen": "브랜드 그린",
    "colors.peachOrange": "복숭아 오렌지",
    "colors.lightBlue": "라이트 블루",
    "colors.lightPink": "라이트 핑크",
    "colors.loadFailed": "색상 설정을 로드하지 못했습니다.",
    "colors.saveFailed": "색상 설정을 저장하지 못했습니다.",
    "colors.importFailed": "색상 설정을 가져오지 못했습니다.",
    "colors.importedCount": "색상 {count}개를 가져왔습니다",
    "colors.recentSaveFailed": "최근 색상을 저장하지 못했습니다.",
    "colors.favoriteSaveFailed": "좋아하는 색상 저장 실패",
    "colors.favoriteDeleteFailed": "좋아하는 색상을 삭제하지 못했습니다.",
    "colors.update": "업데이트",
    "colors.insert": "삽입",
    "colors.pick": "색상을 선택하세요",
    "colors.pickShort": "선택",
    "colors.hexValue": "색상 값",
    "colors.pendingUpdate": "색상이 변경되었습니다. 업데이트를 클릭하여 적용하세요.",
    "colors.save": "저장",
    "colors.exportPs": "내보내기",
    "colors.importPs": "가져오기",
    "colors.done": "완료",
    "colors.manage": "관리",
    "colors.favorites": "좋아하는 색깔",
    "colors.recent": "최근 색상",
    "colors.recentLabel": "최근",
    "colors.deleteFavorite": "좋아하는 색상 삭제{name}",
    "colors.modify": "색상 편집",
    "colors.modifyValue": "색상 수정{value}",
    "colors.removeValue": "색상 제거{value}",
    "taskGroup.today": "오늘",
    "taskGroup.yesterday": "어제",
    "taskGroup.last7": "지난 7일",
    "taskGroup.older": "이전",
    "taskGroup.searchResults": "검색 결과",
    "taskGroup.active": "활성",
    "taskGroup.running": "실행 중",
    "taskGroup.waiting": "대기 중",
    "taskGroup.dispatchPending": "사용 가능한 채널을 할당하는 중...",
    "taskGroup.expand": "확장{label}",
    "taskGroup.collapse": "축소{label}",
    "taskGroup.buttonLabel": "{label}, 작업 {count}개",
    "archive.title": "보관함",
    "archive.empty": "보관된 채팅이 없습니다.",
    "archive.count": "보관된 채팅 {count}개",
    "archive.restore": "복원",
    "archive.archiveFailed": "보관 실패",
    "archive.restoreFailed": "복원 실패",
    "archive.restored": "채팅이 복원되었습니다.",
    "archive.archiving": "보관 중...",
    "archive.restoring": "복원 중...",
    "archive.deleting": "삭제 중...",
    "archive.restoredCount": "작업 {count}개을 복원했습니다.",
    "settings.title": "저장소 설정",
    "settings.status": "저장소 경로를 저장한 뒤 WebUI를 다시 시작하면 적용됩니다",
    "settings.inputRoot": "입력 폴더",
    "settings.outputRoot": "출력 폴더",
    "settings.galleryRoot": "공용 갤러리 폴더",
    "settings.sourceDataRoot": "소스 데이터 폴더",
    "settings.language": "표시 언어",
    "settings.languageCopy": "처음 실행할 때 브라우저 언어 설정을 따릅니다. 직접 선택한 언어는 기억됩니다.",
    "settings.notificationsCopy": "작업이 완료되거나 실패하면 알립니다. 시스템 알림은 직접 켜야 합니다.",
    "settings.inAppNotification": "앱 내 알림",
    "settings.systemNotification": "시스템 알림",
    "settings.save": "설정 저장",
    "settings.loadFailed": "설정을 불러오지 못했습니다",
    "settings.saveFailed": "설정을 저장하지 못했습니다",
    "settings.savedRestart": "저장소 설정이 저장되었습니다. WebUI를 다시 시작하면 적용됩니다.",
    "settings.saved": "저장됨",
    "settings.savedRestartStatus": "저장소 설정이 저장되었습니다. WebUI를 다시 시작하면 적용됩니다.",
    "systemSettings.title": "시스템 설정",
    "systemSettings.tabsLabel": "시스템 설정 섹션",
    "systemSettings.apiTab": "API 설정",
    "systemSettings.codexTab": "Codex 채널",
    "systemSettings.languageTab": "언어 / Language",
    "systemSettings.storageTab": "저장소 및 알림",
    "languageSettings.instantStatus": "언어 변경 사항은 즉시 적용됩니다",
    "apiSettings.title": "API 설정",
    "apiSettings.status": "저장된 설정은 API 모드에 즉시 적용됩니다",
    "apiSettings.codexMode": "Codex채널",
    "apiSettings.codexImages": "이미지",
    "apiSettings.codexResponses": "응답",
    "apiSettings.providers": "API 공급자",
    "apiSettings.searchProviders": "공급자 이름 검색",
    "apiSettings.noProviderSearchResults": "일치하는 공급자가 없습니다",
    "apiSettings.providerCount": "공급자 {count}개",
    "apiSettings.provider": "공급자",
    "apiSettings.providerName": "공급자 이름",
    "apiSettings.actualRequest": "실제 요청",
    "apiSettings.newProviderAction": "공급자 새로 만들기",
    "apiSettings.copyProvider": "복사",
    "apiSettings.copyProviderName": "{name} 복사",
    "apiSettings.copyProviderStatus": "저장된 키를 포함해 공급자를 복사했습니다. 저장하기 전에 이름이나 모델을 편집하거나 키를 교체하세요.",
    "apiSettings.copyProviderWithoutKeyStatus": "공급자가 복사되었습니다. 저장하기 전에 이름, 모델을 편집하거나 API 키를 추가하세요.",
    "apiSettings.sortProviders": "정렬",
    "apiSettings.finishSortProviders": "완료",
    "apiSettings.sortProviderModeStatus": "공급자 정렬 중",
    "apiSettings.sortProviderStatus": "공급자 순서가 변경되었습니다. 자동 저장 중...",
    "apiSettings.moveProviderUp": "위로",
    "apiSettings.moveProviderDown": "아래로",
    "apiSettings.moveProviderUpAria": "{provider}위로 이동",
    "apiSettings.moveProviderDownAria": "{provider}아래로 이동",
    "apiSettings.mode": "호출 방식",
    "apiSettings.images": "Image API 직접 연결",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "직접 연결",
    "apiSettings.imageModel": "이미지 생성 모델",
    "apiSettings.concurrency": "동시 실행 한도",
    "apiSettings.concurrencyShort": "동시 실행",
    "apiSettings.advancedSettings": "고급 설정",
    "apiSettings.concurrencyValue": "동시성{concurrency}",
    "apiSettings.keySaved": "API Key가 저장되었습니다",
    "apiSettings.keyNotSet": "API Key가 설정되지 않았습니다.",
    "apiSettings.showApiKey": "API Key 표시",
    "apiSettings.hideApiKey": "API Key 숨기기",
    "apiSettings.editProvider": "공급자 편집",
    "apiSettings.newProviderTitle": "새 공급자",
    "apiSettings.editHint": "공급자 저장을 누르기 전까지 이 편집 내용은 백엔드에 기록되지 않습니다. 취소하면 폐기됩니다.",
    "apiSettings.finishEditFirst": "먼저 현재 공급자 편집 내용을 저장하거나 취소하세요.",
    "apiSettings.newDraftStatus": "공급자를 만드는 중입니다. 적용하려면 공급자를 저장하세요.",
    "apiSettings.editDraftStatus": "공급자를 편집 중입니다. 적용하려면 공급자를 저장하세요.",
    "apiSettings.cancelEdit": "편집 취소",
    "apiSettings.saveProvider": "공급자 저장",
    "apiSettings.saveSelection": "현재 선택 저장",
    "apiSettings.deleteProviderTitle": "공급자를 삭제할까요?",
    "apiSettings.deleteProviderMessage": "\"{provider}\"을(를) 삭제하시겠습니까?",
    "apiSettings.deleteProviderDetail": "공급자 목록에서 제거되고 백엔드에 자동 저장됩니다.",
    "apiSettings.deleteProviderStatus": "공급자가 삭제되었습니다. 자동 저장 중...",
    "apiSettings.save": "API 설정 저장",
    "apiSettings.loadFailed": "API설정을 로드하지 못했습니다.",
    "apiSettings.savedKeyPlaceholder": "API Key가 백엔드에 저장되었습니다. 교체하려면 새 키를 입력하세요.",
    "apiSettings.newProvider": "새 공급자",
    "apiSettings.saving": "저장 중...",
    "apiSettings.savingStatus": "API 설정을 저장하는 중...",
    "apiSettings.autoSaving": "자동 저장 중...",
    "apiSettings.autoSaved": "자동 저장됨",
    "apiSettings.saveFailed": "API 설정을 저장하지 못했습니다.",
    "apiSettings.savedSummary": "저장됨 · Codex {codex} · API {provider} · {mode} · {model} · 동시 실행 {concurrency}",
    "apiSettings.savedShort": "저장되었습니다",
    "apiSettings.savedStatus": "API 설정이 저장되었습니다.",
    "apiSettings.saveFailedShort": "저장 실패",
    "codexSettings.title": "Codex 채널",
    "codexSettings.status": "로컬Codex로그인을 위한 생성 채널을 선택하세요.",
    "codexSettings.notesLabel": "Codex 채널 설명",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "크기, 품질 및 편집 매개변수를 직접 전달하기 위한 기본 채널입니다.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "웹 검색 도구가 필요한 워크플로를 위한 호환성 채널입니다.",
    "codexSettings.current": "사용 중",
    "codexSettings.save": "Codex 채널 저장",
    "codexSettings.saveMode": "{mode} 저장",
    "imageEditor.title": "입력 이미지 편집",
    "imageEditor.promptHint": "이미지에 손으로 그린 화살표와 표시는 설명일 뿐입니다. 최종 이미지에 보관하지 마세요.",
    "imageEditor.inputFallback": "입력 이미지",
    "imageEditor.openFailed": "편집을 위해 이 이미지를 열지 못했습니다.",
    "imageEditor.loadForEditFailed": "편집을 위해 이 이미지를 로드하지 못했습니다.",
    "imageEditor.canvasCreateFailed": "이미지 편집 캔버스를 생성하지 못했습니다.",
    "imageEditor.closedRegionRequired": "브러시를 사용하여 닫힌 영역을 먼저 그립니다.",
    "imageEditor.saveFailed": "이미지 편집 내용을 저장하지 못했습니다.",
    "imageEditor.saved": "편집된 입력 이미지가 저장되었습니다.",
    "imageEditor.uneditable": "이 이미지는 편집할 수 없습니다",
    "imageEditor.resetDone": "원본 이미지로 재설정",
    "imageEditor.resetFailed": "원본 이미지를 재설정하지 못했습니다.",
    "imageEditor.subtitle": "화살표 자르기, 그리기, 채우기 또는 추가 후 새 입력 이미지로 저장",
    "imageEditor.toolbar": "이미지 편집기 도구 모음",
    "imageEditor.tools": "도구",
    "imageEditor.select": "선택",
    "imageEditor.brush": "브러쉬",
    "imageEditor.arrow": "화살표",
    "imageEditor.crop": "자르기",
    "imageEditor.fill": "채우기",
    "imageEditor.fillLabel": "페인트통 채우기",
    "imageEditor.eraser": "지우개",
    "imageEditor.colors": "색상",
    "imageEditor.red": "빨간색",
    "imageEditor.blue": "블루",
    "imageEditor.green": "녹색",
    "imageEditor.yellow": "노란색",
    "imageEditor.white": "화이트",
    "imageEditor.black": "블랙",
    "imageEditor.customColor": "사용자 정의 색상",
    "imageEditor.stroke": "굵기",
    "imageEditor.history": "기록",
    "imageEditor.undo": "실행 취소",
    "imageEditor.redo": "다시 실행",
    "imageEditor.reset": "이미지 재설정",
    "imageEditor.canvas": "이미지 편집 캔버스",
    "imageEditor.canvasScope": "캔버스 범위",
    "imageEditor.canvasScopeBase": "첫 이미지",
    "imageEditor.canvasScopeFit": "레이어에 맞춤",
    "imageEditor.canvasFitDone": "캔버스를 레이어 범위에 맞췄습니다",
    "imageEditor.canvasBaseDone": "캔버스를 첫 이미지 범위로 되돌렸습니다",
    "imageEditor.insertImages": "이미지 삽입",
    "imageEditor.layers": "레이어",
    "imageEditor.layerUp": "위로 이동",
    "imageEditor.layerDown": "아래로 이동",
    "imageEditor.emptyInsertList": "다른 입력 이미지가 없습니다",
    "imageEditor.selectLayerFirst": "먼저 레이어를 선택하세요",
    "imageEditor.baseLayer": "원본 이미지",
    "gallery.title": "갤러리",
    "gallery.subtitle": "현재 작업에 대한 참조 이미지 선택",
    "gallery.manageCategories": "카테고리 관리",
    "gallery.categoryManager": "갤러리 카테고리 관리",
    "gallery.categoryManagement": "카테고리 관리",
    "gallery.categoryCopy": "카테고리는 갤러리에 저장됩니다. 프롬프트 용도는 참조가 어떻게 사용되는지 설명합니다.",
    "gallery.newCategoryName": "새 카테고리 이름",
    "gallery.newCategoryRole": "프롬프트 용도, 예: 스타일 참조",
    "gallery.addCategory": "카테고리 추가",
    "gallery.drawerSubtitle": "현재 카테고리:{category}. 이미지 입력에 추가하려면 \"사용\"을 클릭하세요.",
    "gallery.emptyCategory": "이 카테고리에는 아직 이미지가 없습니다",
    "gallery.dragSort": "정렬하려면 드래그하세요.",
    "gallery.dragSortImage": "드래그 정렬 이미지{name}",
    "gallery.dragSortCategory": "드래그 정렬 카테고리{name}",
    "gallery.use": "사용",
    "gallery.replace": "교체",
    "gallery.rename": "이름 바꾸기",
    "gallery.moveCategory": "카테고리",
    "gallery.note": "참고",
    "gallery.delete": "삭제",
    "gallery.uncategorized": "분류되지 않음",
    "addGallery.title": "갤러리에 추가",
    "addGallery.copy": "이름은 전역적으로 고유하며 나중에 @name으로 참조할 수 있습니다.",
    "addGallery.name": "이름",
    "addGallery.namePlaceholder": "예: 미아",
    "addGallery.category": "카테고리",
    "addGallery.note": "참고사항",
    "addGallery.notePlaceholder": "예: 옷이나 배경이 아닌 얼굴과 머리카락만 참조하세요.",
    "addGallery.save": "갤러리에 저장",
    "close.promptTemplates": "프롬프트 템플릿 패널 닫기",
    "close.archive": "아카이브 패널 닫기",
    "close.settings": "저장소 설정 패널 닫기",
    "close.apiSettings": "API설정 패널을 닫습니다.",
    "close.systemSettings": "시스템 설정 패널 닫기",
    "close.imageEditor": "이미지 편집기 패널 닫기",
    "close.gallery": "갤러리 패널 닫기",
    "close.addGallery": "갤러리 추가 패널 닫기",
    "close.version": "버전 업데이트 패널 닫기",
    "imageInput.referenceTitle": "참조 입력(선택 사항)",
    "referenceFiles.add": "파일 추가",
    "referenceFiles.selected": "참조 파일",
    "referenceFiles.recent": "최근 파일",
    "referenceFiles.familyPdf": "페이지 + 텍스트",
    "referenceFiles.familySpreadsheet": "스프레드시트",
    "referenceFiles.familyDocument": "문서",
    "referenceFiles.familyText": "텍스트",
    "referenceFiles.visualLimit": "PDF가 아닌 파일에서는 포함된 이미지와 차트가 유지되지 않습니다. 레이아웃 참조가 필요하면 PDF로 변환하세요.",
    "referenceFiles.remove": "{filename} 제거",
    "referenceFiles.switchTitle": "참조 파일을 제거할까요?",
    "referenceFiles.switchMessage": "참조 파일은 Responses에서만 사용할 수 있습니다. Images로 전환하기 전에 선택 파일을 제거하세요.",
    "referenceFiles.removeAndSwitch": "파일 제거 후 전환",
    "referenceFiles.requiresResponses": "참조 파일은 Responses가 필요합니다",
    "referenceFiles.switchToResponses": "Responses로 전환",
    "referenceFiles.openApiSettings": "API 설정 열기",
    "referenceFiles.providerMissing": "원래 Responses 공급자를 사용할 수 없습니다. API 설정에서 선택하세요.",
    "referenceFiles.missing": "파일 없음",
    "referenceFiles.loadFailed": "참조 파일을 불러오지 못했습니다",
    "referenceFiles.errorEmpty": "참조 파일이 비어 있습니다",
    "referenceFiles.errorUnsupported": "지원되지 않는 참조 파일 형식입니다",
    "referenceFiles.errorMismatch": "파일 내용과 확장자가 일치하지 않습니다",
    "referenceFiles.errorInvalid": "참조 파일이 유효하지 않습니다",
    "referenceFiles.errorTooLarge": "참조 파일 하나는 50MB 미만이어야 합니다",
    "referenceFiles.errorTotalTooLarge": "참조 파일 합계는 50MB 이하여야 합니다",
    "referenceFiles.errorMissing": "선택한 참조 파일이 없습니다",
    "referenceFiles.errorProviderUnsupported": "이 공급자의 Responses는 참조 파일을 지원하지 않습니다",
    "referenceFiles.responsesEnabled": "Responses로 전환했습니다",
    "referenceFiles.historyPathMismatch": "참조 파일의 Responses 경로가 서로 다릅니다",
    "history.referenceFiles": "참조 파일",
    "history.downloadReferenceFile": "파일 다운로드",
    "history.readdReferenceFile": "다시 추가",
};
